import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n"; // side-effect init: sets up i18next with all 13 language bundles
import { installLocaleAxiosInterceptor } from "@/i18n/axiosInterceptor";
import App from "@/App";

// Stamp every outbound axios call with the current UI language so backend
// error messages + confirmation emails come back in the customer's chosen tongue.
installLocaleAxiosInterceptor();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
